module.exports = __webpack_public_path__ + "static/media/IMG_5478.7e463743.JPG";